(() => {
  const init = () => document.querySelectorAll('[data-af-product]').forEach(scope => {
    const form = scope.querySelector('.af-product-form');
    const first = form?.querySelector('.af-purchase-row');
    const last = form?.querySelector('[data-af-buy-now-status]');
    if (!first || !last || form.querySelector('.af-mobile-purchase')) return;
    // Move the existing controls only within their original form: no duplicate
    // quantity fields, variant state, IDs or purchase event handlers.
    const slot = document.createElement('div');
    slot.className = 'af-mobile-purchase-slot';
    const bar = document.createElement('div');
    bar.className = 'af-mobile-purchase';
    first.before(slot);
    let node = first;
    while (node) {
      const next = node.nextSibling;
      bar.append(node);
      if (node === last) break;
      node = next;
    }
    slot.append(bar);
    const story = scope.nextElementSibling?.matches('.af-product-story')
      ? scope.nextElementSibling : scope;
    const mobile = matchMedia('(max-width: 749px)');
    let previousTop = scope.getBoundingClientRect().top;
    let upward = false;
    let queued = false;
    const update = () => {
      queued = false;
      const top = scope.getBoundingClientRect().top;
      const delta = top - previousTop;
      if (Math.abs(delta) > 3) { upward = delta > 0; previousTop = top; }
      const height = bar.getBoundingClientRect().height;
      const rect = slot.getBoundingClientRect();
      const viewport = window.innerHeight;
      const pastControls = rect.top + (slot.offsetHeight || height) < 0;
      const storyFinished = story.getBoundingClientRect().bottom <= viewport;
      const floating = mobile.matches && pastControls && (!storyFinished || upward);
      if (floating) slot.style.minHeight = `${height}px`;
      bar.classList.toggle('is-floating', floating);
      if (!floating) slot.style.removeProperty('min-height');
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    // Capture also covers themes whose page scrolls inside a main container.
    document.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    new ResizeObserver(schedule).observe(bar);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
